import { api } from './api';

const AppInfoService = {
  updateAppInfo: (params: any) => {
    return api.authPutForm('/auth/owner/app', params);
  },

  getAppInfo: () => {
    return api.authGet('/auth/owner/app');
  },

  getListCategory: () => {
    return api.authGet('/auth/owner/app/category');
  },

  submitApp: () => {
    return api.authPut('/auth/owner/app/submit');
  },
};

export default AppInfoService;
